import { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

export default function InfiniteCarousel({ images }) {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [direction, setDirection] = useState(1);

  // Duplicate images for infinite effect
  const duplicatedImages = images.length > 0 ? [...images, ...images, ...images] : [];

  useEffect(() => {
    if (images.length === 0) return;

    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => {
        const nextIndex = prevIndex + direction;
        // Reset to beginning when reaching end
        if (nextIndex >= images.length * 2) {
          return images.length; // Jump to middle set
        }
        return nextIndex;
      });
    }, 2000); // Change every 2 seconds

    return () => clearInterval(interval);
  }, [images.length, direction]);

  if (images.length === 0) return null;

  return (
    <div className="relative w-full h-80 overflow-hidden rounded-xl bg-gray-100">
      {/* Continuous sliding container */}
      <motion.div
        className="flex h-full"
        animate={{
          x: `-${(currentIndex * 100) / 3}%`, // Show 3 images at once
        }}
        transition={{
          duration: 0.8,
          ease: "easeInOut"
        }}
      >
        {duplicatedImages.map((image, index) => (
          <div
            key={`${image.id}-${index}`}
            className="flex-shrink-0 w-1/3 h-full relative"
          >
            <img
              src={image.image_url || image.url}
              alt={image.title || 'Gallery Image'}
              className="w-full h-full object-cover"
            />
            <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent p-3">
              <p className="text-white text-sm font-medium truncate">
                {image.title || 'Apartemen Image'}
              </p>
            </div>
          </div>
        ))}
      </motion.div>
      
      {/* Navigation arrows */}
      <button
        onClick={() => {
          setCurrentIndex(prev => prev > 0 ? prev - 1 : images.length - 1);
        }}
        className="absolute left-2 top-1/2 transform -translate-y-1/2 bg-black/50 hover:bg-black/70 text-white p-2 rounded-full transition-colors"
      >
        <i className="fas fa-chevron-left"></i>
      </button>
      
      <button
        onClick={() => {
          setCurrentIndex(prev => (prev + 1) % images.length);
        }}
        className="absolute right-2 top-1/2 transform -translate-y-1/2 bg-black/50 hover:bg-black/70 text-white p-2 rounded-full transition-colors"
      >
        <i className="fas fa-chevron-right"></i>
      </button>
      
      {/* Progress bar */}
      <div className="absolute bottom-2 left-1/2 transform -translate-x-1/2 flex space-x-1">
        {images.map((_, index) => (
          <div
            key={index}
            className={`h-1 rounded-full transition-all duration-300 ${
              index === (currentIndex % images.length) ? 'w-8 bg-white' : 'w-2 bg-white/50'
            }`}
          />
        ))}
      </div>
    </div>
  );
}